'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _chartsPieJs = require('./charts/Pie.js');

var _chartsPieJs2 = _interopRequireDefault(_chartsPieJs);

var _chartsTreeJs = require('./charts/Tree.js');

var _chartsTreeJs2 = _interopRequireDefault(_chartsTreeJs);

var _chartsRadarJs = require('./charts/Radar.js');

var _chartsRadarJs2 = _interopRequireDefault(_chartsRadarJs);

var _chartsBarJs = require('./charts/Bar.js');

var _chartsBarJs2 = _interopRequireDefault(_chartsBarJs);

var _chartsSmoothLineJs = require('./charts/SmoothLine.js');

var _chartsSmoothLineJs2 = _interopRequireDefault(_chartsSmoothLineJs);

var _chartsStockLineJs = require('./charts/StockLine.js');

var _chartsStockLineJs2 = _interopRequireDefault(_chartsStockLineJs);

var _chartsScatterplotJs = require('./charts/Scatterplot.js');

var _chartsScatterplotJs2 = _interopRequireDefault(_chartsScatterplotJs);

//import SmoothLine from './charts/SmoothLineVivus.js';
//import StockLine from './charts/StockLineVivus.js';
//import Bar from './charts/BarVivus.js';
//import Pie from './charts/PieVivus.js';
//import Radar from './charts/RadarVivus.js';
//import Tree from './charts/TreeVivus.js';
//import Scatterplot from './charts/ScatterplotVivus.js';

exports['default'] = {
    Pie: _lodash2['default'].extend(_chartsPieJs2['default'], {
        metaData: {
            settings: {
                fields: {
                    data: { type: 'plainJsonEditor' },
                    accessorKey: { type: 'string' },
                    options: {
                        fields: {
                            width: { type: 'number' },
                            height: { type: 'number' },
                            margin: { type: 'boxSizeEditor' },
                            r: { type: 'number' },
                            R: { type: 'number' },
                            color: { type: 'colorPicker' },
                            legendPosition: {
                                type: 'select',
                                settings: { options: ['topLeft', 'topRight', 'bottomLeft', 'bottomRight'] }
                            },
                            label: { type: 'fontEditor' },
                            animate: {
                                fields: {
                                    type: { type: 'select', settings: { options: ['delayed', 'async', 'oneByOne'] } },
                                    duration: { type: 'number' },
                                    fillTransition: { type: 'number' }
                                }
                            }
                        }
                    }
                }
            }
        }
    }),
    Tree: _lodash2['default'].extend(_chartsTreeJs2['default'], {
        metaData: {
            settings: {
                fields: {
                    data: { type: 'plainJsonEditor' },
                    options: {
                        fields: {
                            width: { type: 'number' },
                            height: { type: 'number' },
                            margin: { type: 'boxSizeEditor' },
                            r: { type: 'number' },
                            fill: { type: 'colorPicker' },
                            stroke: { type: 'colorPicker' },
                            label: { type: 'fontEditor' },
                            animate: {
                                fields: {
                                    type: { type: 'select', settings: { options: ['delayed', 'async', 'oneByOne'] } },
                                    duration: { type: 'number' },
                                    fillTransition: { type: 'number' }
                                }
                            }
                        }
                    }
                }
            }
        }
    }),
    SmoothLine: _lodash2['default'].extend(_chartsSmoothLineJs2['default'], {
        metaData: {
            settings: {
                fields: {
                    data: { type: 'plainJsonEditor' },
                    xKey: { type: 'string' },
                    yKey: { type: 'string' },
                    options: {
                        fields: {
                            width: { type: 'number' },
                            height: { type: 'number' },
                            margin: { type: 'boxSizeEditor' },
                            color: { type: 'colorPicker' },
                            animate: {
                                fields: {
                                    type: { type: 'select', settings: { options: ['delayed', 'async', 'oneByOne'] } },
                                    duration: { type: 'number' },
                                    fillTransition: { type: 'number' }
                                }
                            },

                            axisY: {
                                fields: {
                                    orient: { type: 'select', settings: { options: ['left', 'right'] } },
                                    //tickValues: {type: 'tickValues'},
                                    label: { type: 'fontEditor' },
                                    showAxis: { type: 'boolean' },
                                    showLines: { type: 'boolean' },
                                    showLabels: { type: 'boolean' },
                                    showTicks: { type: 'boolean' },
                                    zeroAxis: { type: 'boolean' }
                                }
                            },
                            axisX: {
                                fields: {
                                    orient: { type: 'select', settings: { options: ['top', 'bottom'] } },
                                    //tickValues: {type: 'tickValues'},
                                    label: { type: 'fontEditor' },
                                    showAxis: { type: 'boolean' },
                                    showLines: { type: 'boolean' },
                                    showLabels: { type: 'boolean' },
                                    showTicks: { type: 'boolean' },
                                    zeroAxis: { type: 'boolean' }
                                }
                            }
                        }
                    }
                }
            }
        }
    }),
    StockLine: _lodash2['default'].extend(_chartsStockLineJs2['default'], {
        metaData: {
            settings: {
                fields: {
                    data: { type: 'plainJsonEditor' },
                    xKey: { type: 'string' },
                    yKey: { type: 'string' },
                    options: {
                        fields: {
                            width: { type: 'number' },
                            height: { type: 'number' },
                            margin: { type: 'boxSizeEditor' },
                            color: { type: 'colorPicker' },
                            animate: {
                                fields: {
                                    type: { type: 'select', settings: { options: ['delayed', 'async', 'oneByOne'] } },
                                    duration: { type: 'number' },
                                    fillTransition: { type: 'number' }
                                }
                            },
                            axisY: {
                                fields: {
                                    orient: { type: 'select', settings: { options: ['left', 'right'] } },
                                    //tickValues: {type: 'tickValues'},
                                    label: { type: 'fontEditor' },
                                    showAxis: { type: 'boolean' },
                                    showLines: { type: 'boolean' },
                                    showLabels: { type: 'boolean' },
                                    showTicks: { type: 'boolean' },
                                    zeroAxis: { type: 'boolean' }
                                }
                            },
                            axisX: {
                                fields: {
                                    orient: { type: 'select', settings: { options: ['top', 'bottom'] } },
                                    //tickValues: {type: 'tickValues'},
                                    label: { type: 'fontEditor' },
                                    showAxis: { type: 'boolean' },
                                    showLines: { type: 'boolean' },
                                    showLabels: { type: 'boolean' },
                                    showTicks: { type: 'boolean' },
                                    zeroAxis: { type: 'boolean' }
                                }
                            }
                        }
                    }
                }
            }
        }
    }),
    Radar: _lodash2['default'].extend(_chartsRadarJs2['default'], {
        metaData: {
            settings: {
                fields: {
                    data: { type: 'plainJsonEditor' },
                    options: {
                        fields: {
                            width: { type: 'number' },
                            height: { type: 'number' },
                            margin: { type: 'boxSizeEditor' },
                            r: { type: 'number' },
                            max: { type: 'number' },
                            fill: { type: 'colorPicker' },
                            stroke: { type: 'colorPicker' },
                            label: { type: 'fontEditor' },
                            animate: {
                                fields: {
                                    type: { type: 'select', settings: { options: ['delayed', 'async', 'oneByOne'] } },
                                    duration: { type: 'number' },
                                    fillTransition: { type: 'number' }
                                }
                            }
                        }
                    }
                }
            }
        }
    }),
    Bar: _lodash2['default'].extend(_chartsBarJs2['default'], {
        metaData: {
            settings: {
                fields: {
                    data: { type: 'plainJsonEditor' },
                    accessorKey: { type: 'string' },
                    options: {
                        fields: {
                            width: { type: 'number' },
                            height: { type: 'number' },
                            margin: { type: 'boxSizeEditor' },
                            gutter: { type: 'number' },
                            color: { type: 'colorPicker' },
                            animate: {
                                fields: {
                                    type: { type: 'select', settings: { options: ['delayed', 'async', 'oneByOne'] } },
                                    duration: { type: 'number' },
                                    fillTransition: { type: 'number' }
                                }
                            },
                            axisY: {
                                fields: {
                                    orient: { type: 'select', settings: { options: ['left', 'right'] } },
                                    //tickValues: {type: 'tickValues'},
                                    label: { type: 'fontEditor' },
                                    showAxis: { type: 'boolean' },
                                    showLines: { type: 'boolean' },
                                    showLabels: { type: 'boolean' },
                                    showTicks: { type: 'boolean' },
                                    zeroAxis: { type: 'boolean' }
                                }
                            },
                            axisX: {
                                fields: {
                                    orient: { type: 'select', settings: { options: ['top', 'bottom'] } },
                                    //tickValues: {type: 'tickValues'},
                                    label: { type: 'fontEditor' },
                                    showAxis: { type: 'boolean' },
                                    showLines: { type: 'boolean' },
                                    showLabels: { type: 'boolean' },
                                    showTicks: { type: 'boolean' },
                                    zeroAxis: { type: 'boolean' }
                                }
                            }
                        }
                    }
                }
            }
        }
    }),
    Scatterplot: _lodash2['default'].extend(_chartsScatterplotJs2['default'], {
        metaData: {
            settings: {
                fields: {
                    data: { type: 'plainJsonEditor' },
                    xKey: { type: 'string' },
                    yKey: { type: 'string' },
                    options: {
                        fields: {
                            width: { type: 'number' },
                            height: { type: 'number' },
                            margin: { type: 'boxSizeEditor' },
                            fill: { type: 'colorPicker' },
                            stroke: { type: 'colorPicker' },
                            label: { type: 'fontEditor' },
                            animate: {
                                fields: {
                                    type: { type: 'select', settings: { options: ['delayed', 'async', 'oneByOne'] } },
                                    duration: { type: 'number' },
                                    fillTransition: { type: 'number' }
                                }
                            },

                            axisY: {
                                fields: {
                                    orient: { type: 'select', settings: { options: ['left', 'right'] } },
                                    //tickValues: {type: 'tickValues'},
                                    label: { type: 'fontEditor' },
                                    showAxis: { type: 'boolean' },
                                    showLines: { type: 'boolean' },
                                    showLabels: { type: 'boolean' },
                                    showTicks: { type: 'boolean' },
                                    zeroAxis: { type: 'boolean' }
                                }
                            },
                            axisX: {
                                fields: {
                                    orient: { type: 'select', settings: { options: ['top', 'bottom'] } },
                                    //tickValues: {type: 'tickValues'},
                                    label: { type: 'fontEditor' },
                                    showAxis: { type: 'boolean' },
                                    showLines: { type: 'boolean' },
                                    showLabels: { type: 'boolean' },
                                    showTicks: { type: 'boolean' },
                                    zeroAxis: { type: 'boolean' }
                                }
                            }
                        }
                    }
                }
            }
        }
    })
};
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-pathjs-chart/lib/Chart.js
 ** module id = 2204
 ** module chunks = 0
 **/